module.exports = __webpack_public_path__ + "707c984ac51c6aa42f8ceec21dcbf49b.MP3";